import { useEffect, useState } from "react";
import IMAGES from "../../../../assets/images/images";
import styles from "./accountManagerwidget.module.css"
import { connect } from "react-redux";
import { isWidgetPresent } from "../../../../utils/arrayUtils";
import Shimmer from "../../../../components/shimmer/Shimmer";
import { getCustomerAm } from "../../../../redux/actions/home/home.action";
import EmptyDataView from "../../../../components/emptydataview/EmptyDataView";
const AccountManagerWidget = ({action,customerAm,...props}) =>{
    const data = customerAm?.accountManagers || []
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isCopied, setIsCopied] = useState(false);
    const totalSteps = Math.ceil(data.length);
    const handlenext = () => {
        if (currentIndex < data.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }
    };
    const handleprevious = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };
    const handleCopy = (text) => {
        navigator.clipboard.writeText(text);
        setIsCopied(true);
    };
    const handleMouseLeave = () => {
        setIsCopied(false);
    };
    useEffect(()=>{
        // isWidgetPresent(props?.myRights?.widgetDetails,action)&&
        props?.getCustomerAm(action)
    },[])
    const retry =() =>{
        props?.getCustomerAm(action)
    }
    return(
        props?.isLoading?<Shimmer/>:<div className={styles.amcard}>
            <div className={styles.header}>
                <div className={styles.headertext}>Vodafone Point of Contact</div>
                {data?.length===0&&!props?.isLoading&&
                <div className={styles.retryparent} onClick={retry}> <div className={styles.retryicon}></div><div className={styles.refresh}>Refresh</div></div>}
            </div>
            <div className={styles.body}>
                {data?.length===0?<div className={styles.emptydiv}><EmptyDataView/></div>:
                <>
                {currentIndex > 0 && <span className={`${styles.leftarrow} ${styles.arrowparent}`} onClick={() => handleprevious()}><img src={IMAGES.montharrow} className={styles.arrowicon} /></span>}
                <div className={`${styles.amlist}`}>
                    <div className={styles.userwrapper}>
                    <img src={IMAGES.usericon} className={styles.usericon} />
                    </div>
                    <div className={styles.wrapper}>
                        <div className={styles.name}>{data[currentIndex]?.name}</div>
                        <div className={styles.email}><span className={styles.emailtext}>{data[currentIndex]?.email}</span><span><img src={isCopied ? IMAGES.success : IMAGES.copy} className={styles.copy} onClick={() => handleCopy(data[currentIndex].email)} onMouseLeave={handleMouseLeave}/></span></div>
                    </div>
                </div>
                {currentIndex < totalSteps - 1 && <span className={`${styles.rightarrow}  ${styles.arrowparent}`} onClick={() => handlenext()}><img src={IMAGES.montharrow} className={styles.arrowicon} /></span>}
                </>}
            </div>
            {data?.length>1&&(
            <div className={styles.dotpagination}>
            {data.map((_, index) => (
                    <span key={index} className={`${styles.dot} ${currentIndex === index ? styles.activeDot : ''}`} onClick={() => setCurrentIndex(index)}/>
                ))}
            </div>)}  
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        customerAm:state?.dashBoardCounts?.customerAm?.data,
        isLoading:state?.dashBoardCounts?.customerAm?.isLoading,
        myRights : state.myRights.myRights,
    }
  }
  const mapDispatchToProps = (dispatch)=>{
    return {
        getCustomerAm: (action) => {
          return dispatch(getCustomerAm(action))
        },
    }
  }

export default connect(mapStateToProps,mapDispatchToProps)(AccountManagerWidget);
